import { render, staticRenderFns } from "./index.vue?vue&type=template&id=42f38cb6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=42f38cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f38cb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/s01-aiart-release-cn/s01_haiyiai_release-cn_aiart-web-openapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42f38cb6')) {
      api.createRecord('42f38cb6', component.options)
    } else {
      api.reload('42f38cb6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=42f38cb6&scoped=true&", function () {
      api.rerender('42f38cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/purchase/index.vue"
export default component.exports